import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { LoadingSpinner } from '../../../components/base';
import { AppRedirectPageWrapper } from './styles';
import { selectOrganization, selectApp, } from '@project/containers/Root/actions';
import storageService from '@project/utils/storageService';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedApp } from '../../../store/selectedApp/selectors';
import { makeSelectOrganizations } from '../../Root/selectors';
import { loadSelectedApp } from '../../../store/selectedApp/actions';
import { selectMe } from '../../Root/selectors';
import { Navigate, useLocation } from 'react-router-dom';
var AppRedirectPage = function () {
    var _a, _b, _c;
    var dispatch = useDispatch();
    var pathname = useLocation().pathname;
    var pathNameArray = pathname === null || pathname === void 0 ? void 0 : pathname.split('/');
    var appId = pathNameArray[2];
    var allOrganizations = useSelector(makeSelectOrganizations());
    useEffect(function () {
        appId && dispatch(loadSelectedApp(appId));
    }, [appId, dispatch]);
    var selectedApp = useSelector(selectSelectedApp);
    var selectedAppOrgIdSplit = (_b = (_a = selectedApp === null || selectedApp === void 0 ? void 0 : selectedApp.app) === null || _a === void 0 ? void 0 : _a.owner) === null || _b === void 0 ? void 0 : _b.split(':');
    var selectedAppOrgId = selectedAppOrgIdSplit
        ? selectedAppOrgIdSplit[1]
        : null;
    var me = useSelector(selectMe);
    var currentOrganization = storageService.getItem('selectedOrganizationId');
    dispatch(selectApp(appId));
    if (selectedAppOrgId && selectedAppOrgId !== currentOrganization) {
        dispatch(selectOrganization(selectedAppOrgId, me === null || me === void 0 ? void 0 : me.id));
    }
    return appId === 'new' ? (_jsx(Navigate, { to: "/organizations" })) : selectedAppOrgId ? (_jsx(Navigate, { to: "/organizations/".concat(selectedAppOrgId).concat(pathname) })) : (appId === '' || !appId) && currentOrganization ? (_jsx(Navigate, { to: "/organizations/".concat(currentOrganization).concat(pathname) })) : (appId === '' || !appId) && (allOrganizations === null || allOrganizations === void 0 ? void 0 : allOrganizations.length) > 0 ? (_jsx(Navigate, { to: "/organizations/".concat((_c = allOrganizations[0]) === null || _c === void 0 ? void 0 : _c.id, "/apps") })) : appId === '' || !appId ? (_jsx(Navigate, { to: "/organizations" })) : (_jsx(AppRedirectPageWrapper, { children: _jsx(LoadingSpinner, {}) }));
};
export default AppRedirectPage;
